import {
    IDefaultTableColumnConfig,
    IWebsiteReferrerConfig,
    IMultiLevelDualAxisLineGraphConfig,
    ICardHeaderConfig } from '../../../../_shared/models/models-index';

export class WebsiteReferrerConfig implements IWebsiteReferrerConfig {
    public reportTitle: string;
    public benchmarkCardHeader: ICardHeaderConfig = null;
    public graphConfig: IMultiLevelDualAxisLineGraphConfig = null;
    public summaryTableColumns: IDefaultTableColumnConfig[] = [];
}
